import { Card, CardContent, Grid } from '@material-ui/core'

import { format, parseISO } from 'date-fns'

import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'

import { useStyles } from './work-list-comments.styles'

export const WorkListCommentCard = ({ comment }) => {
  const classes = useStyles()

  return (
    <Card className={classes.commentCard}>
      <CardContent className={classes.commentCardContent}>
        <Grid container>
          <Grid item container style={{ marginBottom: 16 }}>
            <Grid item style={{ marginRight: 12 }}>
              <AsterTypography style={{ color: PRIMARY_COLORS[700] }}>
                {comment?.userFullName || ''}
              </AsterTypography>
            </Grid>

            <Grid item>
              {comment?.createdDate && (
                <AsterTypography style={{ color: GRAY_COLORS[400] }}>
                  {format(parseISO(comment.createdDate), 'HH:mm dd.MM.yyyy')}
                </AsterTypography>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <AsterTypography>{comment?.text || ''}</AsterTypography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
